import { Typography } from '@mui/material';
import React from 'react';
import { Link, useMatch } from 'react-router-dom';
import { Header } from '../../../../components/singleComponents/headers';
import { ConstructionBudgets } from '../budgets/ConstructionBudgets';
import { ConstructionDashboard } from '../dashboard/ConstructionDashboard';
import { ConstructionDocuments } from '../documents/ConstructionDocuments';
import { ConstructionPayable } from '../payables/ConstructionPayable';
import { ConstructionPhotos } from '../photos/ConstructionPhotos';
import { ConstructionSchedules } from '../schedules/ConstructionSchedules';

import { HeadersLinkStyled } from './index.styles';

export function PageDetails() {
  let slug = '';
  let id = null;
  const match = useMatch('/constructions-details/:id/:slug');

  if (match) {
    id = match.params.id;
    slug = match.params.slug;
  }

  return (
    <>
      <Header />
      <HeadersLinkStyled>
        <Link to="/client">Início</Link>
        &gt;
        <Link to={`/constructions-details/${id}`}>Detalhamento de obra</Link>
        &gt;
        {slug === 'photos' && (
          <Typography variant="h5" style={{ fontWeight: '400' }}>
            Fotos
          </Typography>
        )}
        {slug === 'payables' && (
          <Typography variant="h5" style={{ fontWeight: '400' }}>
            Lançamentos
          </Typography>
        )}
        {slug === 'documents' && (
          <Typography variant="h5" style={{ fontWeight: '400' }}>
            Documentos
          </Typography>
        )}
        {slug === 'dashboard' && (
          <Typography variant="h5" style={{ fontWeight: '400' }}>
            Dashboard
          </Typography>
        )}
        {slug === 'budgets' && (
          <Typography variant="h5" style={{ fontWeight: '400' }}>
            Orçamento
          </Typography>
        )}
        {slug === 'schedules' && (
          <Typography variant="h5" style={{ fontWeight: '400' }}>
            Cronograma
          </Typography>
        )}
      </HeadersLinkStyled>
      {slug === 'photos' && <ConstructionPhotos />}
      {slug === 'documents' && <ConstructionDocuments />}
      {slug === 'payables' && <ConstructionPayable />}
      {slug === 'dashboard' && <ConstructionDashboard />}
      {slug === 'budgets' && <ConstructionBudgets />}
      {slug === 'schedules' && <ConstructionSchedules />}
    </>
  );
}
